// @flow
import React, { Component } from 'react';
import ReactSVG from 'react-svg';

import YearSelect from '../YearSelect';
import { Wrapper, svgStyle } from './style';

import ChevronOuvre from '../../assets/images/chevron_ouvre.svg';

import type { Years } from '../../types/Criteria';
import { setFacetState } from '../../actions/ui';
import connect from 'react-redux/es/connect/connect';

type Props = {
  title: string,
  onChange: Years => void,
  years: Years,
  setFacetState: (string, boolean) => void,
  facetState: {
    years: boolean
  }
};

type State = {
  collapse: boolean
};

class DateFilter extends Component<Props, State> {
  state = {
    collapse: false
  };

  static getDerivedStateFromProps(props: Props, state: State) {
    return {
      ...state,
      collapse: !props.facetState.years
    };
  }

  handleCollapse = (): void =>
    this.props.setFacetState('years', this.state.collapse);

  render() {
    const { collapse } = this.state;
    const { title, years, onChange } = this.props;

    return (
      <Wrapper>
        <div className="filter-header" onClick={this.handleCollapse}>
          <div className="filter-title">{title}</div>
          <div
            className="filter-icon"
            style={{ transform: collapse ? 'rotate(0deg)' : 'rotate(180deg)' }}
          >
            <ReactSVG svgStyle={svgStyle} src={ChevronOuvre} />
          </div>
        </div>

        <div
          className="filter-content-container"
          style={{ maxHeight: collapse ? '0' : `9999px` }}
        >
          <div
            className="filter-content"
            style={{
              maxHeight: collapse ? '0' : `300px`
            }}
          >
            <YearSelect
              firstYear={years.min}
              lastYear={years.max}
              onChange={onChange}
              updateInPlace={false}
              width="300px"
            />
          </div>
        </div>
      </Wrapper>
    );
  }
}

const mapStateToProps = ({ ui: { facetState } }) => ({
  facetState
});

const mapDispatchToProps = dispatch => {
  return {
    setFacetState: (facet, value) => dispatch(setFacetState(facet, value))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DateFilter);



// WEBPACK FOOTER //
// ./src/components/DateFilter/index.js